import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'removeExtensionString',
    standalone: true,
    pure: true,
})
export class RemoveExtensionStringPipe implements PipeTransform {

  transform(value: string): string {
    if (value.indexOf('.') > -1) {
      value = value.substring(0, value.lastIndexOf('.'));
    }
    return value;
  }
}
